import type { NotificationAssignProjectCardProps } from "./notification-assign-project-card.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { BatchPreviewAssignLink } from "@/modules/batch-preview/batch-preview-assign-link";
import ModelIcon from "@/modules/model-icon";
import { ModelLink } from "@/modules/model-link";
import { NotificationCard } from "@/modules/notification/notification-card";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";

const { Paragraph } = Typography;

export const NotificationAssignProjectCard = ({
  notification,
}: NotificationAssignProjectCardProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  const { type, data } = notification;
  const { context, projects, user } = data;
  const color = "var(--app-color-info)";
  const count = projects.length;
  const ids = projects.map(({ id }) => id);

  return (
    <NotificationCard
      notification={notification}
      icon={<ModelIcon model="project" style={{ color }} />}
      title={t("notification:projectAssign.title", { count })}
      color={color}
      subTitle={user.name}
      content={
        <Paragraph ellipsis={{ rows: 2 }}>
          {t("notification:projectAssign.description", {
            userName: user.name,
            projectName: projects[0]?.name ?? "",
            count,
          })}
        </Paragraph>
      }
      actions={
        <>
          {count === 1 ? (
            <ModelLink
              model="project"
              item={projects[0]}
              showIcon="external"
              modelAsName
              customContext={context}
              onClick={closePanel}
            />
          ) : (
            <BatchPreviewAssignLink
              type={type}
              userName={user.name}
              ids={ids}
              customContext={context}
              onClick={closePanel}
              icon="external"
            />
          )}
          <OrganizationContextLabel context={context} isSmall />
        </>
      }
    />
  );
};
